import { css } from '@linaria/atomic';
import { ContainedIcon } from '@frontend/icons';

const transferredContainedIconStyle1 = css`
  padding: 1px;
  border-radius: var(--fabric-radius-sm);
`;

export const Transferred = ({ as = 'span' }: { as?: React.ElementType }) => {
  return (
    <ContainedIcon
      as={as}
      className={transferredContainedIconStyle1}
      iconName='call-source'
      color={'var(--fabric-color-neutral-50)'}
    />
  );
};
